// Carga lazy de pdfmake — import() dinámico solo se dispara cuando el usuario
// hace click en "Exportar", no forma parte del bundle inicial de /panel.
//
// Se usa la fuente estándar Helvetica (standard-fonts/Helvetica.js, ~296KB sin
// comprimir, cubre tildes/ñ/¿/¡ vía WinAnsiEncoding) en vez del vfs_fonts.js
// default de pdfmake (~836KB, tipografía Roboto embebida) — verificado con un
// smoke test en Node: sin esto, pdfmake tira
// "File 'data/Helvetica.afm' not found in virtual file system" al intentar
// medir texto, incluso pidiendo font: 'Helvetica' explícitamente. El fix es
// `pdfMake.addFontContainer(helveticaFontContainer)`, que registra tanto la
// tabla de fuentes como los datos AFM en el virtual filesystem interno.

let pdfMakePromise: Promise<any> | null = null;

export function getPdfMake(): Promise<any> {
  if (!pdfMakePromise) {
    pdfMakePromise = Promise.all([
      import('pdfmake/build/pdfmake.min.js'),
      import('pdfmake/build/standard-fonts/Helvetica.js'),
    ]).then(([pdfMakeModule, helveticaModule]) => {
      const pdfMake: any = (pdfMakeModule as any).default ?? pdfMakeModule;
      const helvetica: any = (helveticaModule as any).default ?? helveticaModule;
      pdfMake.addFontContainer(helvetica);
      return pdfMake;
    });
  }
  return pdfMakePromise;
}

// Convierte el logo (servido como asset estático) a dataURI — pdfmake no
// acepta URLs relativas como `image`, solo dataURI o paths de filesystem
// (Node). Se resuelve una sola vez y se cachea en memoria.
let logoDataUriPromise: Promise<string | null> | null = null;

export function getLogoDataUri(logoPath: string): Promise<string | null> {
  if (!logoDataUriPromise) {
    logoDataUriPromise = fetch(logoPath)
      .then((res) => (res.ok ? res.blob() : Promise.reject(new Error('logo fetch failed'))))
      .then(
        (blob) =>
          new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      )
      .catch(() => null);
  }
  return logoDataUriPromise;
}
